<template>
    <a-layout-header class="header flex x-between y-center">
        <!-- <img src="~@/assets/images/logo.png" class="logo" alt=""> -->
        <!-- <a-breadcrumb>
            <a-breadcrumb-item>设计</a-breadcrumb-item>
            <a-breadcrumb-item>PC网站设计</a-breadcrumb-item>
        </a-breadcrumb> -->
        <div @click="$emit('menubar-change')" class="pl15 pr15 flex y-center x-center" style="cursor: pointer">
            <a-icon v-if="menubar" style="font-size: 18px" type="menu-fold" />
            <a-icon v-else style="font-size: 18px" type="menu-unfold" />
        </div>
        <div class="bold wap-hide fs16 flex-item row-1">{{ meetingInfo[$route.params.lang + '_title'] }}{{ forum_name == 'undefined' || !forum_name ? '' : ' - ' + forum_name }}</div>
        <div class="flex x-left y-center">
            <div class="nav-list">
                <a href="javascript:;" @click="handleNavigateEvent" class="nav-item wap-hide">
                    <!-- 预览前台 -->
                    {{ $t('layout.preview') }}
                </a>
                <a href="javascript:;" :title="$t('web.download_center_title' /* 任务中心下载 */)" class="nav-item">
                    <a-badge @click="handleDownModalEvent" :count="downNumber">
                        <a-icon class="fs18 mr5" type="download" />
                    </a-badge>
                </a>
                <!-- <a href="javascript:;" @click="handleTabLangEvent" class="nav-item">{{$route.params.lang == 'cn' ? 'English' : '简体中文'}}</a> -->
            </div>

            <a style="display: inherit" class="mr15 wap-hide" href="javascript:window.location.reload();"><a-icon class="fs14 color000" type="sync" /></a>

            <template>
                <span @click="handleTabLangEvent()" v-if="language == 'en'" class="medcon med-zhongwen1 color333 fs20 mr15 pointer"></span>
                <span @click="handleTabLangEvent()" v-else class="medcon med-yingwen1 color333 fs20 mr15 pointer"></span>
            </template>

            <template>
                <a v-if="isFullScreen" @click="exitFullscreen" style="display: inherit" class="mr20" href="javascript:;"><a-icon class="fs14 color000" type="fullscreen-exit" /></a>
                <a v-else @click="requestFullScreen" style="display: inherit" class="mr20 wap-hide" href="javascript:;"><a-icon class="fs14 color000" type="fullscreen" /></a>
            </template>

            <a-dropdown>
                <a class="ant-dropdown-link color000 flex y-center" @click="e => e.preventDefault()">
                    <a-avatar v-if="userInfo.Avatar" :src="userInfo.Avatar | urlFilter(250)" />
                    <a-avatar v-else icon="user" />
                    <span class="ml5">{{ userInfo.RealName }}</span>
                    <a-icon class="fs14" type="down" />
                </a>
                <a-menu class="t-c" slot="overlay">
                    <!-- <a-menu-item>
                    <a href="javascript:;">基本信息</a>
                </a-menu-item>
                <a-menu-item>
                    <a href="javascript:;">我的订单</a>
                </a-menu-item> -->
                    <a-menu-item class="logout-btn">
                        <a @click="handleLogoutEvent" href="javascript:;">
                            <!-- 安全退出 -->
                            {{ $t('layout.exit') }}
                        </a>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
        </div>
        <down-all ref="downAll"></down-all>
    </a-layout-header>
</template>

<script>
import { mapState } from 'vuex';
import { base_url } from '@/config/const';
import storage from 'store';
import downAll from './down.vue';
export default {
    name: 'AdminLayoutHeader',
    components: { downAll },
    props: {
        menubar: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(['userInfo', 'meetingInfo', 'downNumber'])
    },
    data() {
        return {
            isFullScreen: false,
            forum_name: '',
            language: 'cn'
        };
    },
    watch: {
        $route: {
            handler(newVal) {
                this.language = window.location.hash.match(/(cn|en)/)[0];
            },
            immediate: true
        }
    },
    methods: {
        handleDownModalEvent() {
            this.$refs.downAll.show();
        },
        handleNavigateEvent() {
            let { forum_id, meeting_id } = this.$route.params;
            let href = window.location.href;
            let url = '';
            let idNum = this.meetingInfo?.forum?.id;

            if (href.indexOf('mobile-config') != -1) {
                if (forum_id) {
                    if (idNum) {
                        url = `${this.$store.getters.m_base_url}/cn/forum-minisite/index/${idNum}`;
                    } else {
                        url = 'javascript:;';
                    }
                } else {
                    url = `${this.$store.getters.m_base_url}/cn/minisite/index/${meeting_id}`;
                }
            } else {
                if (forum_id) {
                    if (idNum) {
                        url = `${this.$store.getters.m_base_url}/cn/forum-web/index/${idNum}`;
                    } else {
                        url = `${this.$store.getters.m_base_url}/cn/web/index/${meeting_id}`;
                    }
                } else {
                    url = `${this.$store.getters.m_base_url}/cn/web/index/${meeting_id}`;
                }
            }

            if (this.meetingInfo.default_page_type == '3' && !forum_id) {
                url = this.$store.getters.m_base_url;
            }
            window.open(url);
        },

        // 切换语言包
        async handleTabLangEvent() {
            let { lang, forum_id, meeting_id } = this.$route.params;
            lang = lang == 'en' ? 'cn' : 'en';
            let path = '/' + lang + '/' + meeting_id;
            forum_id && (path += '/' + forum_id);
            await this.$router.push(path);
            window.location.reload();
        },
        // 监听是否全屏
        judegIsFullScreen() {
            window.onresize = () => {
                // 可视区域的高度
                const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
                // screen是window的属性方法，window.screen可省略window，指的是窗口
                this.isFullScreen = screen.height == clientHeight;
            };
        },
        // 全屏
        requestFullScreen() {
            //开启全屏
            let element = document.getElementById('app');
            let requestMethod =
                element.requestFullScreen || //w3c
                element.webkitRequestFullScreen || // Chrome等
                element.mozRequestFullScreen || // FireFox
                element.msRequestFullScreen; // IE11
            if (requestMethod) {
                requestMethod.call(element);
            }
        },

        // 退出全屏
        exitFullscreen() {
            //退出全屏
            if (document.exitFullScreen) {
                document.exitFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        },

        // 退出登录
        handleLogoutEvent() {
            // 删除php 那边的token
            storage.remove('token');
            //+'?return_url='+web_base_url
            let { m_committee_id } = this.$store.state?.meetingInfo || {};
            window.location.href = base_url + 'site/logout/' + m_committee_id;
        }
    },
    mounted() {
        this.judegIsFullScreen();
        this.$store.dispatch('getNowDownNumber');
        this.forum_name = window.sessionStorage.getItem('forum_name');
    }
};
</script>

<style lang="less" scoped>
.header {
    height: 50px;
    line-height: 50px;
    background: #fff;
    box-shadow: 0 2px 8px #f0f1f2;
    padding: 0 @gap;
    .logo {
        width: 240px;
        height: 40px;
        object-fit: contain;
    }
    .nav-item {
        padding: 12px 15px;
        color: #595757;
    }
    .logout-btn {
        border-top: 1px solid #f1f1f1;
        /deep/a {
            color: @error-color;
        }
    }
}
@media screen and (max-width: 768px) {
    .wap-hide {
        display: none !important;
    }
}
</style>
